import { useEffect, useState } from "react"
import { decodeStorage, encodeStorage, removeStorage } from "newFunctions/storageBase64"
import { privateApiGet } from "functions/privateApi"

const endpoint = '/credito-sears/v1/internet/card/list'

export const useValidateAccount = () => {
    const [ flow, setFlow] = useState( null ) 
    const [ access_token, setAccess_token ] = useState( null )
    const [ sears_numero_internet, setSears_numero_internet ] = useState( null )
    const [ cardending, setCardending ] = useState( null )
    const [ account, setAccount] = useState( null ) 
    const [ dataCard, setDataCard] = useState( null ) 
    const [ showView, setShowView ] = useState( false )
    const pathname = window.location.pathname

    const getListCards = async () => {     
        try{
            if(access_token){
                const result = await privateApiGet(endpoint)
                
                if (result.statusCode === 200 && result.data) {
                    const data = result.data
                    if (data) {
                        const card = data?.cards[0]?.card_ending
                        const numInt = data?.cards[0]?.no_internet
                        if (card && numInt) {
                            encodeStorage('sears_numero_internet', numInt)
                            encodeStorage('cardending', card)
                            setSears_numero_internet( numInt )
                            setCardending( card )
                        }else{
                            setFlow(2)
                        }
                    }
                }else if (result.statusCode === 401) {
                    console.warn('Token expired, will retry with refresh...')
                }else if (result.statusCode >= 400) {
                    setFlow(2)
                }
                else {
                    console.error('Error fetching list of cards:', result.error);
                }
            }
        }
        catch (error) {
            console.error('Error fetching list of cards:', error);
        }
    }

    useEffect(()=>{
        setAccess_token( decodeStorage('access_token') )
        setSears_numero_internet( decodeStorage('sears_numero_internet') )
        setCardending( decodeStorage('cardending') )
    },[])

    useEffect(()=>{
        if(access_token){
            if ( (sears_numero_internet && sears_numero_internet !== "undefined") || (sears_numero_internet && cardending) ) {
                if (cardending) {
                    // console.log('3: ', sears_numero_internet,' : ',cardending)
                    setFlow(3)
                    setShowView(true)
                }else{
                    setFlow(2)
                    setShowView(true)
                }
            }else{
                removeStorage('infoPersonalStorage')
                removeStorage('infoPersonal2Storage')
                removeStorage('infoTrabajoStorage')
                removeStorage('infoFinancieraStorage')
                removeStorage('infoPersonalMobileStorage')
                removeStorage('infoTrabajoMobileStorage')
                removeStorage('infoFinancieraMobileStorage')
                getListCards()
            }
        }else if(access_token === ''){
            setFlow(1)
            setTimeout(() => (
                setShowView(true)
            ),700)
        }
    },[ access_token, sears_numero_internet, cardending ])

    
    return {
        flow,
        account,
        dataCard,
        showView
    }
}